<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>تیکت‌های من</h3>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="tid"
                                    select-all
                                    :custom-sort="sortByTid"
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.tid }}</td>
                                    <td class="text-xs-center">{{ props.item.title }}</td>
                                    <td class="text-xs-center" style="direction: ltr">{{ toJalali(props.item.created_at) }}</td>
                                    <td class="text-xs-center">{{ getDepartmentById(props.item.department_id) }}</td>
                                    <td class="text-xs-center">
                                        <v-chip :color="getStatus(props.item.status)" text-color="white">
                                            {{ props.item.status }}
                                        </v-chip>
                                    </td>
                                    <td class="text-xs-center">
                                        <v-btn depressed outline icon fab dark color="primary" @click="$router.push(`/pages/tickets/show/`+props.item.tid)" small>
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شماره‌تیکت',
            value: 'tid',
            align: 'center'
          },
          {
            text: 'عنوان',
            value: 'title',
            align: 'center'
          },
          {
            text: 'تاریخ درخواست',
            value: 'created_at',
            align: 'center'
          },
          {
            text: 'دپارتمان',
            value: 'department_id',
            align: 'center'
          },
          {
            text: 'وضعیت',
            value: 'status',
            align: 'center'
          },
          {
            text: 'مشاهده',
            value: '',
            align: 'center'
          },
        ],
        items: []
      },
      departments: []
    };
  },
  created: function () {
    this.axios.get('/reseller/reseller_ticket_departments/')
      .then(response => {
        this.departments = response.data.Data;
        this.axios.get('/reseller/tickets/?is_main=1')
          .then(response => {
            this.complex.items = response.data.data;
          })
          .catch(error => {
            this.snackbar = HttpErrorToSnackbar(error);
          });
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    getDepartmentById (id) {
      let i = this.departments.findIndex(d => d.dep_id === id);
      if (i < 0) {
        return '';
      }
      return this.departments[i].name;
    },
    getStatus (p) {
      switch (p) {
        case 'منتظر بررسی':
          return 'primary';
        case 'بسته‌شده':
          return 'black';
        case 'منتظر پاسخ مشتری':
          return 'orange';
        case 'درحال بررسی':
          return 'green';
        default:
          return 'yellow';
      }
    }
  },
  sortByTid (data) {
    return data.sort((a, b) => {
      return b.tid - a.tid;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/tickets/list.vue